import { showNotification } from "@mantine/notifications"
import { useMutation } from "@tanstack/react-query"

import { JobExecutionsRequests } from "@costory/types/endpoints/jobExecutions"

import { apiClient } from "@costory/front/lib/apiClient"
import { queryClient } from "@costory/front/lib/queryClient"

export const useJobCreation = () => {
  return useMutation({
    mutationFn: async (type: string) => {
      const response = await apiClient.post<JobExecutionsRequests.StartJob>(
        `/job-executions/start-job/${type}/`,
      )
      return response.data
    },
    onSuccess: async (_data, type) => {
      await queryClient.invalidateQueries({
        queryKey: ["jobExecutions", type],
      })
      showNotification({
        color: "green",
        title: "Job Started",
        message: "The job is running",
      })
    },
    onError: (error: { error: string }) => {
      showNotification({
        color: "red",
        title: "Error",
        message: error.error,
      })
    },
  })
}
